
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    wysiwygEditor: {
        "& .rdw-dropdown-selectedtext, & .demo-editor, & .DraftEditor-root, & .DraftEditor-editorContainer": {
            color: "#000000de !important",
        },
    },
    wysiwygEditorNewTheme: {
        "& .rdw-editor-toolbar": {
            marginBottom: "0 !important",
        },
    },
    InputLabel: {
        marginTop: 10
    },
    TextField: {
        width: "100%",
        "& .MuiInputBase-input": {
            fontSize: "14px !important",
        },
        "& .MuiInputBase-root": {
            minHeight: "43px !important",
        },
        "& .MuiChip-root": {
            fontSize: "14px !important",
        },
    },
    TextArea: {
        width: '100%',
    },
    gridStyle1: {
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
        alignItems: 'flex-start'
    },
    gridStyle2: {
        display: 'flex',
        gap: '5px'
    },
    tableContainer: {
        marginTop: 20,
        maxHeight: "530px",
        overflowY: "auto",
        overflowX: "auto",
    },
    themetableContainer: {
        marginTop: 16,
        // maxHeight: "530px",
        overflowY: "auto",
        overflowX: "auto",
        boxShadow: "none !important",
        height: "calc(100vh - 420px)",
    },
    tableHeadRow: {
        height: "40px !important",
        backgroundColor: "#ddd !important",
        position: "sticky",
        top: 0,
        zIndex: 2,
    },
    themeTableHeadRow: {
        height: "40px !important",
        border: "1px solid #E9EBF5",
        borderRadius: "4px",
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: "#fff !important",
    },
    tableHeadCell: {
        color: "black",
        fontSize: "14px",
        padding: "12px 16px"
    },
    themetableHeadCell: {
        borderRight: "1px solid #E9EBF5",
        color: "black",
        fontSize: "14px",
        padding: "12px 16px"
    },
    tableRowEven: {
        backgroundColor: "#f9f9f9 !important",
    },
    tableRowOdd: {
        backgroundColor: "#ffffff !important",
    },
    tableCell: {
        padding: "4px 8px !important",
        fontSize: "14px",
        lineHeight: "1.5 !important",
        whiteSpace: "normal",
    },
    themetableCell: {
        padding: "4px 8px !important",
        fontSize: "14px",
        lineHeight: "1.5 !important",
        whiteSpace: "normal",
        borderRight: "1px solid #E9EBF5",
    },
    tableRow: {
        height: "auto !important",
        minHeight: "20px !important"
    },
    themetableRow: {
        height: "auto !important",
        minHeight: "20px !important",
        border: "1px solid #E9EBF5",
        borderRadius: "4px",
    },
    actionIcons: {
        color: "#555",
        border: "1px solid #ddd",
        borderRadius: "6px",
        padding: "2px",
        backgroundColor: "transparent",
        transition: "all 0.3s ease",
        "&:hover": {
            color: "#000",
            borderColor: "#aaa",
        },
        marginRight: "5px",
    },
    themeactionIcons: {
        padding: "0px",
    },
    iconSize: {
        fontSize: "14px",
    },

    editClause: {
        marginTop: "10px",
        position: "relative",
        overflow: "visible",
        maxWidth: "80%"
    },
    updateTemplate: {
        dispaly: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    confirmationDialoge: {
        "& .MuiDialog-paperWidthSm": {
            height: "250px",
            width: "600px"
        }
    },
    actionsContainer: {
        display: "flex",
        alignItems: "center",
        gap: "5px",
        flexWrap: "nowrap",
        position:'relative'
    },
    table: {
        minWidth: "100px",
        minHeight: "425px"
    },
    searchIcon: {
        fontSize: 32,
    },
    clauseDataGrid: {
        marginTop: 10,
        position: 'relative',
        overFlow: 'auto',
        maxWidth: '80%',
        height: 'calc(100vh - 200px)',
        overflowX: 'hidden',
        
    },
    clauseList: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 10
    },
    newclauseList:{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 16
    },
    // clauseDataDiv: {
    //     display: "flex",
    //     justifyContent: "space-between",
    //     alignItems: "center",
    //     width: "100%"
    // },
    clauseDataDiv: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: 16
    },
    DataGridItem: {
        width: '50%',
    },
    fullWidth: {
        width: '100%',
    },
    formLabel: {
        width: '100px',
    },
    formInput: {
        width: 'calc(100% - 100px)',
    },
    backIconCls:{
        border: "1px solid #E9EBF5", borderRadius: "4px", padding: 0
    },
        chipSelect: {
        '& input': {
            height: 27,
        },
        '& div[class^="ChipSelect-valueContainer"]': {
            padding: '8px !important',  
            gap: 2,
        },
        '& .MuiChip-root': { 
            backgroundColor: '#fff !important',
            border: '1px solid #D5D6DD !important',     
        },   
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D6DD !important',  
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#303F9F !important',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3F51B5 !important',
        },
        
    },
    textField: {
          '& .MuiOutlinedInput-input': {
          padding: '14px !important',
          fontSize: '12px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#D5D6DD !important',  
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#303F9F !important',
          },

          '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#3F51B5 !important',
          },
    },
    lables:{
        color: '#78798E',
        fontSize: '12px',
        lineHeight: '17px',
        marginBottom:6
    }, 
    newThemeForm: {
        border: '1px solid #E9EBF5',
        borderRadius: '4px',
    },
    newThemeFieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
    },
    newThemeField: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    newThemeInput: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
            backgroundColor: '#FFFFFF',
            border: '1px solid #E0E0E0',
            '&:hover': {
                borderColor: '#BDBDBD',
            },
            '&.Mui-focused': {
                borderColor: '#3F51B5',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '12px 16px',
            fontSize: '14px',
            color: '#000000de',
            '&::placeholder': {
                color: '#9E9E9E',
                opacity: 1,
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
    },
    newThemeTextAreaContainer: {
        position: 'relative',
    },
    newThemeTextArea: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
            backgroundColor: '#FFFFFF',
            border: '1px solid #E0E0E0',
            '&:hover': {
                borderColor: '#BDBDBD',
            },
            '&.Mui-focused': {
                borderColor: '#3F51B5',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '12px 16px',
            fontSize: '14px',
            color: '#000000de',
            '&::placeholder': {
                color: '#9E9E9E',
                opacity: 1,
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
    },
    newThemeWordCounter: {
        color: '#9E9E9E',
        fontSize: '12px',
        marginTop: '4px',
        textAlign: 'right',
    },
    newThemeSliderContainer: {
        padding: '16px',
    },
    newThemeSliderLabels: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    newThemeSliderLabel: {
        color: '#78798E',
        fontSize: '14px',
        fontWeight: 400,
    },
  
    newThemeActions: {
        display: 'flex',
        gap: '12px',
        marginTop: '32px',
        justifyContent: 'flex-end',
    },
        update:{
        borderRadius: "4px",
        border: "1px solid #3F51B5",
        background: "#3F51B5",
        color: '#fff',
        textTransform: 'capitalize',
        height: '30px',
        boxSizing: 'border-box',
        boxShadow: 'none',
        "&:hover": {
            background: "#303F9F",
            color: "#fff",
            boxShadow: 'none',
        },
    },
    cancel:{
       borderRadius: "4px", 
       border: "1px solid #3F51B5",
       color: '#3F51B5',
       background: "#fff",
       textTransform: 'capitalize',
       height: '30px',
       boxSizing: 'border-box',
       boxShadow: 'none',
       "&:hover": {
        boxShadow: 'none',       
       },
    },
    newThemeSlider:{
        color: '#9B3FFF',
        width: '98%',

    },
    buttonContainer:{
      borderTop: '1px solid #E0E0E0', 
      padding: 10,
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      gap: 10
    },
    paginationSelect: {
        minWidth: '80px',
        border: '1px solid #eee',
        borderRadius: 4,
        fontSize: 12,
        fontWeight: "400 !important",
        "& .MuiInputBase-root": {
            fontSize: "12px !important",
            fontWeight: 400,
        },
        '& .MuiSelect-select': {
            padding: '5px 12px 6px 12px',
            fontWeight: '400 !important',
        },
        "& .MuiInput-underline::before": {
            borderBottom: "none !important",
        },
        "& .MuiInput-underline::after": {
            borderBottom: "none !important",
        },
    },
    pagination: {
    minWidth: '50px',
    border: '1px solid #eee',
    borderRadius: 4,
    fontSize: 12,
    fontWeight: "400 !important",
    "& .MuiInputBase-root": {
        fontSize: "12px !important",
        fontWeight: 400,
        width: '55px !important',
    },
    '& .MuiSelect-select': {
        padding: '5px 12px 6px 12px',
    },
    '& .app-cvm .MuiSelect-select.MuiSelect-selec': {
        fontWeight: "400 !important",
    },
    "& .MuiInput-underline::before": {
        borderBottom: "none !important",
    },
    "& .MuiInput-underline::after": {
        borderBottom: "none !important",
    },
},
    actionBtnContent: {
        width: 150,
        padding: "4px",
        borderRadius: "4px",
        backgroundColor: "#ffffff",
        position: "absolute",
        right: "calc(100% + 5px)",
        top: "5px",
        display: "none",
        boxSizing: "border-box",
        boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.25)",
        flexDirection:'column',
        gap:'10px',
        "& label": {
            borderRadius: '0px !important',
            '&:hover': {
                backgroundColor: '#f5f5f5 !important',
            }
        },
        "&.active": {
            display: "flex",
        },

    },
    buttonBox: {
    color: '#202426',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
    // padding: 8,
    fontSize: 14,
    fontWeight: 400,
    "& svg": {
        height: 18,
        width: 18,
    },
    "& span": {
        maxWidth: '100px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'inline-block',
    },
     '&:hover': {
      backgroundColor: '#eee !important',
    }
},
}));
export default useStyles


